import { ICONSAX_SIZE } from "../Iconsax/Iconsax.types.js";
import { rem } from "../Theme/Theme.constants.js";

export const DEFAULT_TRANSITION_DURATION_MS = 175;

export const OPEN_WIDTH = rem(16.5);

export const CLOSED_WIDTH = `calc(${ICONSAX_SIZE.LARGE}px + ${rem(3.5)})`;

export const DEFAULT_EXTRA_MENU_WIDTH = rem(20);
